module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/common/circle_sp-11acafc342a654049c25394c459cdb61.svg";